import L from 'leaflet';
import { PixiMarker } from '../PixiMarker';
import { InjectionKey, Ref } from 'vue';

export { default as PixiMarkerLayer } from './PixiMarkerLayer';

export interface PixiMarkerLayerInjection {
    utils: Ref<L.PixiOverlayUtils | undefined>;
    addMarker: (marker: InstanceType<typeof PixiMarker>) => void;
    removeMarker: (marker: InstanceType<typeof PixiMarker>) => void;
    renderFrame: () => void;
    showTooltip: (latLng: L.LatLngExpression, tooltipContent: string) => void;
    hideTooltip: (delay?: number) => void;
    moveTooltip: (latLng: L.LatLngExpression) => void;
    raiseMarkerClickedEvent: () => void;
}

export const PixiMarkerLayerInjectionKey: InjectionKey<PixiMarkerLayerInjection> = Symbol.for('travelplanner:pixiMarkerLayer');
